import React, { memo, useEffect, useState } from 'react';

import { Lottie } from '@uncinc/uncinc-react-kitchen-sink';

const LottieInline = memo(({
  url,
  lottieId,
  className = '',
}) => {
  const [json, setJson] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isErrored, setIsErrored] = useState(false);

  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then(setJson)
      .catch(setIsErrored)
      .then(() => setIsLoaded(true));
  }, [url]);

  return (
    <Lottie
      id={lottieId}
      data={JSON.parse(json)}
      autoPlay
      loop
    />
  );
});

export default LottieInline;
